import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import usePrevious from '../../services/usePrevious/usePrevious.js';
import PollManager from '../../services/poller/PollManager.js';
import { refreshDoorWindowAsync } from './TestMagnetSlice.js';

var state = {
  NOT_STARTED: 'NOT_STARTED',
  FIRST_TEST_COMPLETED: 'FIRST_TEST_COMPLETED',
  TEST_COMPLETED: 'TEST_COMPLETED'
};
var useTestMagnet = function useTestMagnet(client, giid, deviceLabel) {
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3000;
  var _useState = useState(state.NOT_STARTED),
    _useState2 = _slicedToArray(_useState, 2),
    testState = _useState2[0],
    setTestState = _useState2[1];
  var _useState3 = useState('UNKNOWN'),
    _useState4 = _slicedToArray(_useState3, 2),
    magnetState = _useState4[0],
    setMagnetState = _useState4[1];
  var previousMagnetState = usePrevious(magnetState);
  var pollKey = 'pollMagnet';
  var pollDoorWindowState = function pollDoorWindowState(key) {
    PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var magnet;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refreshDoorWindowAsync(client, giid, deviceLabel);
            case 2:
              magnet = _context.sent;
              setMagnetState(magnet.state);
              return _context.abrupt("return", false);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), {
      key: key,
      interval: interval,
      timeout: Infinity
    });
  };
  useEffect(function () {
    if (magnetState === 'UNKNOWN' || previousMagnetState === 'UNKNOWN') {
      return;
    }
    if (testState === state.NOT_STARTED && previousMagnetState === 'CLOSE' && magnetState === 'OPEN') {
      setTestState(state.FIRST_TEST_COMPLETED);
    } else if (testState === state.FIRST_TEST_COMPLETED && previousMagnetState === 'OPEN' && magnetState === 'CLOSE') {
      setTestState(state.TEST_COMPLETED);
      PollManager.cancel(pollKey);
    }
  }, [magnetState, testState, previousMagnetState]);
  useEffect(function () {
    return function () {
      PollManager.cancel(pollKey);
    };
  }, []);
  var startTest = function startTest() {
    pollDoorWindowState(pollKey);
  };
  return {
    testState: testState,
    magnetState: magnetState,
    startTest: startTest
  };
};

export { useTestMagnet as default, state };
